import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const Collapse = (props) => (
  <Icon viewBox="0 0 13 1" {...props}>
    <g>
      <title>Combined Shape</title>
      <path d="M7 0h5.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H7z" fill="currentColor" fillRule="nonzero" />
    </g>
  </Icon>
);
/*eslint-enable */

export default Collapse;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/Collapse.js